import React from 'react';
import BaseVegetableCharacter from './BaseVegetableCharacter';

const CucumberCharacter = (props) => {
    const primaryColor = "#2e7d32"; // Cucumber green
    const secondaryColor = "#1b5e20"; // Darker green for details

    const renderCucumberBody = () => (
        <>
            {/* Cucumber Body - elongated cylinder */}
            <mesh castShadow rotation={[Math.PI/2, 0, 0]}>
                <cylinderGeometry args={[0.15, 0.15, 0.6, 16]} />
                <meshStandardMaterial color={primaryColor} />
            </mesh>

            {/* Cucumber bumps */}
            {[...Array(12)].map((_, i) => {
                const angle = (i / 12) * Math.PI * 2;
                const y = (i % 3 - 1) * 0.15; // Distribute in 3 rings
                const radius = 0.16;
                const x = Math.sin(angle) * radius;
                const z = Math.cos(angle) * radius;

                return (
                    <mesh key={i} position={[x, y, z]} castShadow>
                        <sphereGeometry args={[0.03, 6, 6]} />
                        <meshStandardMaterial color={secondaryColor} />
                    </mesh>
                );
            })}

            {/* Cucumber stem/flower end */}
            <mesh castShadow position={[0, 0.3, 0]}>
                <cylinderGeometry args={[0.02, 0.05, 0.1, 8]} />
                <meshStandardMaterial color="#4caf50" />
            </mesh>
        </>
    );

    return (
        <BaseVegetableCharacter
            {...props}
            renderBody={renderCucumberBody}
            primaryColor={primaryColor}
            secondaryColor={secondaryColor}
        />
    );
};

export default CucumberCharacter;
